import React, { useContext } from 'react';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import PropTypes from 'prop-types';
import IntegrationPageSectionContext from './StateManagement/IntegrationPageSectionContext';
import SectionContentWrapper from './SectionContentWrapper';

const PageSectionWrapper = ({ ecmIntegContent = {} }) => {
  const {
    SdkConfigurator: { sdkSettings }
  } = useContext(IntegrationPageSectionContext);
  return (
    <PayPalScriptProvider options={sdkSettings}>
      <SectionContentWrapper ecmIntegContent={ecmIntegContent} />
    </PayPalScriptProvider>
  );
};

PageSectionWrapper.propTypes = {
  ecmIntegContent: PropTypes.object.isRequired
};

export default PageSectionWrapper;
